import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { WEB_BASE_URL } from '../unified/webbase';
import cookie from 'react-cookies';
import moment from 'moment';
function MerchantKYCStatus() {
  const [kycData, setKycData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchKycStatus();
  }, []);

  const fetchKycStatus = async () => {
    const token = cookie.load('token');
    try {
      const response = await axios.get(`${WEB_BASE_URL}/onboarding/get-kyc-merchant`, {
        headers: {
          'Authorization': token
        }
      });

      if (response.data.status === '2000') {
        setKycData(response.data.data);
      } else {
        toast.error(response.data.description || 'Failed to fetch KYC status');
      }
    } catch (error) {
      toast.error(error.response?.data?.description || 'An error occurred while fetching KYC status');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <div className="row">
          <div className="col-12 col-lg-8 col-xl-8 mx-auto">
            <div className="card radius-10">
              <div className="card-body">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!kycData) {
    return (
      <div className="page-content">
        <div className="row">
          <div className="col-12 col-lg-8 col-xl-8 mx-auto">
            <div className="card radius-10">
              <div className="card-body">
                <div className="text-center">
                  <h5 className="mb-3">No KYC Information Found</h5>
                  <p className="text-muted mb-4">
                    Please complete your KYC verification to access all merchant features.
                  </p>
                  <Link to="/merchant-kyc" className="btn btn-primary px-4">
                    Complete KYC Verification
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="row">
        <div className="col-12 col-lg-8 col-xl-8 mx-auto">
          <div className="card radius-10">
            <div className="card-body">
              <div className="d-flex align-items-center mb-4">
                <h6 className="mb-0">KYC Verification Status</h6>
                {/* //approve, pending, reject */}
                {kycData.status === 'Pending' && (
                  <span className="badge bg-warning ms-2">
                    Pending
                  </span>
                )}    
                {kycData.status === 'approved' && (
                  <span className="badge bg-success ms-2">
                    Approved
                  </span>
                )}    
                {kycData.status === 'rejected' && (
                  <span className="badge bg-danger ms-2">
                    Rejected
                  </span>
                )}    
                
              </div>

              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Business Name</label>
                    <p className="form-control-static">{kycData.businessName}</p>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Email Address</label>
                    <p className="form-control-static">{kycData.emailAddress}</p>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label className="form-label fw-bold">NIN</label>
                    <p className="form-control-static">{kycData.nin}</p>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Certificate Number</label>
                    <p className="form-control-static">{kycData.certificate || 'Not provided'}</p>
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Date Submitted</label>
                    <p className="form-control-static">
                      {moment(kycData.dateCreated).format('MMMM D, YYYY h:mm A')}
                    </p>
                  </div>
                </div>

                {kycData.imageUrl && (
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label fw-bold">Uploaded Document</label>
                      <div className="mt-2">
                        {kycData.imageUrl.toLowerCase().endsWith('.pdf') ? (
                          <a 
                            href={kycData.imageUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn btn-outline-primary"
                          >
                            View PDF Document
                          </a>
                        ) : (
                          <img
                            src={kycData.imageUrl}
                            alt="KYC Document"
                            className="img-fluid rounded"
                            style={{ maxHeight: '300px' }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {kycData.status === 'Pending' && (
                  <div className="col-12">
                    <div className="alert alert-info">
                      <i className="bi bi-info-circle me-2"></i>
                      Your KYC verification is under review. This process typically takes 1-5 business days.
                    </div>
                  </div>
                )}

                {kycData.status === 'rejected' && (
                  <div className="col-12">
                    <div className="alert alert-danger">
                      <i className="bi bi-exclamation-triangle me-2"></i>
                      Your KYC verification was rejected. Please update your information and submit again.
                    </div>
                    <Link to="/merchant-kyc" className="btn btn-primary">
                      Update KYC Information
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MerchantKYCStatus; 